<!-- DESKTOP VIEW -->
<section
  class="hidden md:flex flex-col justify-center px-4 lg:px-6 xl:px-8 py-8 sm:py-10 mb-8 sm:mb-12 font-bold text-white bg-blue-600 w-full"
>
  <div
    class="flex flex-wrap gap-6 lg:gap-10 justify-between items-center w-full"
  >
    <article
      *ngFor="let item of staticdata"
      class="flex gap-3 sm:gap-4 justify-center items-center my-auto shrink-0"
    >
      <img
        [src]="item.imageUrl"
        class="object-contain shrink-0 self-stretch my-auto w-12 lg:w-16 aspect-square"
        [alt]="item.altText"
      />
      <div
        class="flex flex-col justify-center self-stretch my-auto"
        [style.width]="item.textWidth || 'auto'"
      >
        <h3 class="text-xl lg:text-2xl leading-none font-bold whitespace-nowrap">
          {{ item.title }}
        </h3>
        <p class="mt-1 text-sm lg:text-base font-normal whitespace-nowrap opacity-90">{{ item.text }}</p>
      </div>
    </article>
  </div>
</section>

<!-- MOBILE VIEW -->
<section
  class="flex justify-center items-center p-4 mx-auto my-0 w-full bg-blue-500 md:hidden"
>
  <div class="grid grid-cols-2 gap-x-3 gap-y-4 w-full max-w-md">
    <div
      *ngFor="let item of staticdata"
      class="flex gap-2 items-center min-w-0"
    >
      <div>
        <img
          [src]="item.imageUrl"
          class="w-8 h-8 object-contain"
          [alt]="item.altText"
        />
      </div>
      <div class="flex flex-col gap-0.5 justify-center items-start">
        <h3 class="text-sm font-bold text-white max-md:text-sm max-sm:text-xs">
          {{ item.title }}
        </h3>
        <p class="text-xs text-white text-left max-md:text-xs max-sm:text-xs">
          {{ item.text }}
        </p>
      </div>
    </div>
  </div>
</section>
